import PropTypes from "prop-types";

export const AddOnCategoryModel = {
  id: null,
  name: "",
  description: "",
  sortOrder: 0,
  active: true,
};

export const AddOnCategoryShape = {
  id: PropTypes.number,
  name: PropTypes.string,
  description: PropTypes.string,
  sortOrder: PropTypes.number,
  active: PropTypes.bool,
};
